import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { usePageMeta } from "../hooks/usePageMeta";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Metodo } from "../components/home/Metodo";
import { CTABand } from "../components/CTABand";

const ITEMS = [
  "Lavorazioni edili per imprese e studi tecnici",
  "Opere murarie per conto terzi",
  "Supporto operativo e gestione delle attività di cantiere",
  "Ristrutturazione di locali commerciali e uffici",
  "Manutenzione ordinaria e straordinaria di immobili",
  "Collaborazioni continuative con operatori del settore",
];

export default function Aziende() {
  usePageMeta(
    "Lavori Edili per Aziende e Cantieri in Veneto | Costruzioni Ciosko",
    "Costruzioni Ciosko affianca imprese, aziende e professionisti con lavorazioni edili professionali e gestione organizzata delle attività di cantiere in Veneto."
  );
  return (
    <>
      <PageHero
        overline="Edilizia per imprese"
        lines={["Un partner affidabile", "per i tuoi cantieri"]}
        description="Per imprese, aziende, professionisti e realtà che necessitano di un partner affidabile per lavorazioni edili e gestione delle attività di cantiere."
        image="/images/aziende.jpg"
      />
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <Reveal>
            <div className="steel-frame">
              <div className="aspect-[4/5] overflow-hidden border border-steel">
                <img src="/images/aziende.jpg" alt="Cantiere edile professionale per aziende" loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1.2s]" />
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <h2 className="h-display text-2xl sm:text-3xl text-white">Come possiamo affiancarti</h2>
            <p className="text-cement leading-relaxed mt-5 text-[15px] sm:text-base">
              Lavoriamo al fianco di imprese, aziende e professionisti che cercano un interlocutore serio e
              organizzato: squadre coordinate, cantieri ordinati, comunicazione chiara e rispetto delle
              tempistiche concordate.
            </p>
            <ul className="mt-8 space-y-3.5">
              {ITEMS.map((it, i) => (
                <li key={i} className="flex items-start gap-3 text-sm sm:text-[15px] text-metal/85">
                  <CheckCircle2 size={17} className="text-forest-glow shrink-0 mt-0.5" /> {it}
                </li>
              ))}
            </ul>
            <Link to="/contatti" data-testid="aziende-cta-button" className="btn-primary mt-9">
              Collabora con noi <ArrowRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
      <Metodo />
      <CTABand />
    </>
  );
}
